export default __webpack_public_path__ + "static/media/list_main_10_1.acea06a3.png";